import { type ReactNode, useEffect } from "react";
import { redirectToHubLogin } from "./hubUrl";
import { useSession } from "./useSession";

interface RequireAuthProps {
  loadingFallback?: ReactNode;
  children: ReactNode;
}

export function RequireAuth({
  loadingFallback = null,
  children,
}: RequireAuthProps) {
  const { user, loading } = useSession();
  useEffect(() => {
    if (!loading && !user) redirectToHubLogin();
  }, [user, loading]);
  if (loading) return <>{loadingFallback}</>;
  if (!user) return <>{loadingFallback}</>;
  return <>{children}</>;
}
